import React, {useState} from "react";
import AddUser from "../../components/Modal/AddUser";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/ProtectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import UsersTable from "./usersTable";

const UsersComponent = () => {
  const [modalStatus, setModalStatus] = useState(false);
  return (
    <SafeView>
      <ProtectedContent perms={["view_user"]} showFallback>
        <>
          {modalStatus && (
            <AddUser open={modalStatus} onClose={() => setModalStatus(false)} />
          )}
          <ProtectedContent perms={["add_user"]}>
            <CommonHeader
              content={"Add User"}
              handleAddClick={() => setModalStatus(true)}
              testID={"add_user"}
            />
          </ProtectedContent>
          <div className="table-container">
            <UsersTable />
          </div>
        </>
      </ProtectedContent>
    </SafeView>
  );
};

const UsersList = () => {
  return (
    <PageURLContextProvider>
      <UsersComponent />
    </PageURLContextProvider>
  );
};

export default UsersList;
